<mat-toolbar>
  <mat-toolbar-row class="navbar">
    <div class="nav-bar__wrapper">
      <div class="nav-bar__left">
        <mat-icon class="menu-bar" (click)="toggleMenu()">menu</mat-icon>
        <img class="logo-image" src="/assets/images/dso-logo.png" alt="dso_logo">
        <p class="heading-h6-regular" style="margin: auto;" (click)="navigateToLandingPage()">{{ headerString }}</p>
      </div>
      
      <global-search>
      <form #searchForm="ngForm" class="search-bar-form paragraph-medium-regular" (ngSubmit)="onSearchSubmit()">
        <!-- <div class="search-bar form-inputs" style = "border: 3px solid black"> ---------- Archived by Clement ----------->
          <input type="text" name="query" [(ngModel)]="search.query" placeholder="Search by Document No."/>
          <button type="submit" mat-raised-button color="primary" class="primary-button">Search</button>
        <!-- </div> -->
      </form>
      <div class="menu-button clickable-link" (click)="goUserGuideURL()">
        <img class="icon-image" src="/assets/images/menu_book.svg" alt="MMS_img">
          <span class="paragraph-medium-regular">User Guide & Training videos</span>
      </div>
      <div class="menu-button clickable-link" (click)="goToFAQ()">
        <mat-icon>help_outline</mat-icon>
        <span class="paragraph-medium-regular">FAQ</span>
    </div>
      </global-search>

      <div class="nav-bar__right">
        <p class="nav-bar__avatar paragraph-medium-regular">{{this.loggedInUser.fullName}}</p>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>